"use client";

import NotebookSession from "./notebook-session";

const TechnicalSessionContainer = ({ sessionId }: { sessionId: string }) => {
  return (
    <div className="h-full w-full">
      <NotebookSession sessionId={sessionId} />
    </div>
  );
};

export default TechnicalSessionContainer;
